import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';
import { ConstantsUtil } from '@utils';
import { API_GRID_FAILURE, API_GRID_FETCH, API_GRID_SUCCESS, CLOSE_ALL_GRIDS, CLOSE_ALL_GRIDS_REQUEST, CLOSE_GRID, CLOSE_GRID_REQUEST, GRID_INIT, GRID_INIT_REQUEST, UPDATE_API_GRID_FETCH, UPDATE_GRID, UPDATE_GRID_REQUEST } from './grids.action-types';
export var actions = {
  /**
   * Request grid initiation.
   *
   * @author Mikhail Siutsou
   * @function gridInitRequest
   * @category Actions
   * @subcategory Grids
   * @param {ModalClosePayload} payload payload.
   */
  gridInitRequest: function gridInitRequest(payload) {
    return {
      type: GRID_INIT_REQUEST,
      payload: payload
    };
  },

  /**
   * Grid init.
   *
   * @author Mikhail Siutsou
   * @function gridInit
   * @category Actions
   * @subcategory Grids
   * @param {ModalClosePayload} payload payload.
   */
  gridInit: function gridInit(payload) {
    return {
      type: GRID_INIT,
      payload: payload
    };
  },

  /**
   * Request grid updating.
   *
   * @author Mikhail Siutsou
   * @function gridUpdateRequest
   * @category Actions
   * @subcategory Grids
   * @param {ModalPayload} payload payload.
   */
  gridUpdateRequest: function gridUpdateRequest(payload) {
    return {
      type: UPDATE_GRID_REQUEST,
      payload: payload
    };
  },

  /**
   * Update grid.
   *
   * @author Mikhail Siutsou
   * @function gridUpdate
   * @category Actions
   * @subcategory Grids
   * @param {ModalPayload} payload payload.
   */
  gridUpdate: function gridUpdate(payload) {
    return {
      type: UPDATE_GRID,
      payload: payload
    };
  },

  /**
   * Request grid closing.
   *
   * @author Mikhail Siutsou
   * @function gridCloseRequest
   * @category Actions
   * @subcategory Grids
   * @param {GridClosePayload} payload payload.
   */
  gridCloseRequest: function gridCloseRequest(payload) {
    return {
      type: CLOSE_GRID_REQUEST,
      payload: payload
    };
  },

  /**
   * Close grid.
   *
   * @author Mikhail Siutsou
   * @function gridClose
   * @category Actions
   * @subcategory Grids
   * @param {GridClosePayload} payload payload.
   */
  gridClose: function gridClose(payload) {
    return {
      type: CLOSE_GRID,
      payload: payload
    };
  },

  /**
   * Request all grids closing.
   *
   * @author Mikhail Siutsou
   * @function closeAllGridsRequest
   * @category Actions
   * @subcategory Grids
   */
  closeAllGridsRequest: function closeAllGridsRequest() {
    return {
      type: CLOSE_ALL_GRIDS_REQUEST
    };
  },

  /**
   * Close all grids.
   *
   * @author Mikhail Siutsou
   * @function closeAllGrids
   * @category Actions
   * @subcategory Grids
   */
  closeAllGrids: function closeAllGrids() {
    return {
      type: CLOSE_ALL_GRIDS
    };
  },

  /**
   * Api grid fetch.
   *
   * @author Mikhail Siutsou
   * @function gridApiFetch
   * @category Actions
   * @subcategory Grids
   * @param {GridApiFetchPayload<T, R>} payload payload.
   */
  gridApiFetch: function gridApiFetch(payload) {
    var _ref;

    return _ref = {
      type: API_GRID_FETCH,
      payload: payload
    }, _defineProperty(_ref, WAIT_FOR_ACTION, "".concat(API_GRID_FETCH, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)), _defineProperty(_ref, ERROR_ACTION, "".concat(API_GRID_FETCH, "/").concat(ConstantsUtil.actions.ASYNC_FAILED)), _ref;
  },

  /**
   * Update api grid fetch.
   *
   * @author Mikhail Siutsou
   * @function gridUpdateApiFetch
   * @category Actions
   * @subcategory Grids
   * @param {GridApiFetchPayload<T, R>} payload payload.
   */
  gridUpdateApiFetch: function gridUpdateApiFetch(payload) {
    var _ref2;

    return _ref2 = {
      type: UPDATE_API_GRID_FETCH,
      payload: payload
    }, _defineProperty(_ref2, WAIT_FOR_ACTION, "".concat(UPDATE_API_GRID_FETCH, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)), _defineProperty(_ref2, ERROR_ACTION, "".concat(UPDATE_API_GRID_FETCH, "/").concat(ConstantsUtil.actions.ASYNC_FAILED)), _ref2;
  },

  /**
   * Grid api success.
   *
   * @author Mikhail Siutsou
   * @function gridApiSuccess
   * @category Actions
   * @subcategory Grids
   * @param {GridPayload<T>} payload payload.
   */
  gridApiSuccess: function gridApiSuccess(payload) {
    return {
      type: API_GRID_SUCCESS,
      payload: payload
    };
  },

  /**
   * Grid api failure.
   *
   * @author Mikhail Siutsou
   * @function gridApiFailure
   * @category Actions
   * @subcategory Grids
   * @param {GridPayload<T>} payload payload.
   */
  gridApiFailure: function gridApiFailure(payload) {
    return {
      type: API_GRID_FAILURE,
      payload: payload
    };
  }
};